'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClassNoLongerAvailable = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClassNoLongerAvailable = exports.ClassNoLongerAvailable = function ClassNoLongerAvailable(_ref) {
  var classAlias = _ref.classAlias,
      venueAlias = _ref.venueAlias,
      scheduleId = _ref.scheduleId;
  return _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'alc.purchase.error.no-spots',
    defaultMessage: 'Oops, this class is no longer available. {link} to try and book another class.',
    values: {
      link: _react2.default.createElement(
        _reactRouter.Link,
        {
          to: '/classes/' + venueAlias + '/' + classAlias + '/' + scheduleId,
          target: '_self'
        },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'alc.purchase.error.no-spots.go-back',
          defaultMessage: 'Go back'
        })
      )
    }
  });
};

ClassNoLongerAvailable.propTypes = {
  classAlias: _propTypes2.default.string.isRequired,
  venueAlias: _propTypes2.default.string.isRequired,
  scheduleId: _propTypes2.default.number.isRequired
};